const Pdata = [
    {
        imgscr: "/images/aurora-1197753_640.jpg",
        uploader: "Alejandro Escamilla",
    },
    {
        imgscr: "/images/jasper-national-park-5819878_640.jpg",
        uploader: "Alejandro Escamilla",
    },
    {
        imgscr: "/images/japan-1792369_640.jpg",
        uploader: "Paul Jarvis",
    },
    {
        imgscr: "/images/pexels-asad-photo-maldives-3293148.jpg",
        uploader: "Tina Rataj",
    },
    {
        imgscr: "/images/pexels-evgeny-tchebotarev-4101555.jpg",
        uploader: "Lukas Budimaier",
    },
    {
        imgscr: "/images/waterfalls-2447450_640.jpg",
        uploader: "Danielle Macinnes",
    },
]

export default Pdata;